import { useParams } from 'react-router-dom';
import { motion } from 'framer-motion';

import {
  Nav,
  PrimarySection,
  SecondarySection,
  PhoneSection,
  DesktopSection,
  TabletSection,
  ProjectFooter,
  Panels,
  StarsCanvas,
} from '../components';

import { useData, useScroll } from '../hooks';
import { ProjectStyles } from '../styles/styles';
import { Animations } from '../utils/animations';

type Params = {
  projectID: string;
};

const Project = () => {
  const { scrollRef } = useScroll();
  const { projectID } = useParams<Params>();
  const normalizedProjectID = projectID ?? '';
  const { getData } = useData();
  const { transition, angleTextReveal } = Animations();

  const {
    title,
    sequence,
    text,
    secondary,
    phoneImgSrc,
    desktopImgSrc,
    tabletImgSrc,
    mobileFirst,
    githubLink,
    liveLink,
    next,
  } = getData(normalizedProjectID);

  return (
    <>
      <Nav />
      <Panels />
      <ProjectStyles
        initial={{ backgroundColor: '#0f0e0e', pointerEvents: 'none' }}
        animate={{ backgroundColor: 'transparent', pointerEvents: 'unset' }}
        exit={{
          opacity: [1, 1, 0],
          transition: { duration: 2, times: [0, 0.99, 1] },
        }}
        ref={scrollRef}
        data-scroll-container>
        <div data-scroll-section className="number">
          <div className="number-wrapper">
            <motion.h1
              className="opacity-[0.7]"
              variants={angleTextReveal}
              initial="initial"
              animate="animate"
              transition={{ ...transition, duration: 2, delay: 3 }}>
              0
            </motion.h1>
          </div>
          <div className="number-wrapper">
            <motion.h1
              className="opacity-[0.8]"
              variants={angleTextReveal}
              initial="initial"
              animate="animate"
              transition={{ ...transition, duration: 2, delay: 3.4 }}>
              {sequence}
            </motion.h1>
          </div>
        </div>
        <PrimarySection
          title={title}
          texts={text}
          githubLink={githubLink}
          liveLink={liveLink}
        />
        <SecondarySection secondary={secondary} />
        {mobileFirst && desktopImgSrc.length > 0 && phoneImgSrc.length > 0 && (
          <>
            <PhoneSection phoneImgSrc={phoneImgSrc} />
            <DesktopSection desktopImgSrc={desktopImgSrc} />
          </>
        )}
        {mobileFirst &&
          desktopImgSrc.length === 0 &&
          phoneImgSrc.length > 0 && <PhoneSection phoneImgSrc={phoneImgSrc} />}
        {!mobileFirst && phoneImgSrc.length > 0 && (
          <>
            <DesktopSection desktopImgSrc={desktopImgSrc} />
            <PhoneSection phoneImgSrc={phoneImgSrc} />
          </>
        )}
        {tabletImgSrc.length > 0 && (
          <TabletSection tabletImgSrc={tabletImgSrc} />
        )}
        <ProjectFooter next={next} />
        <StarsCanvas />
      </ProjectStyles>
    </>
  );
};

export default Project;
